/* unplugin-vue-components disabled */import { render } from "./guideTheme.vue?vue&type=template&id=bda1cfb8&scoped=true"
import script from "./guideTheme.vue?vue&type=script&lang=js"
export * from "./guideTheme.vue?vue&type=script&lang=js"

import "./guideTheme.vue?vue&type=style&index=0&id=bda1cfb8&scoped=true&lang=scss"
import "./guideTheme.vue?vue&type=style&index=1&id=bda1cfb8&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda1cfb8"]])

export default __exports__